import FormRegister from "pages/LandingPages/FormRegister";

export default function FormRegisterPage() {
  return <FormRegister />;
}
